import { useToggleMbtcMutation } from "@workspace/casino_core/mutations/ToggleMbtcMutation.client";
import { useUpdateMyDefaultCurrencyMutation } from "@workspace/casino_core/mutations/UpdateMyDefaultCurrencyMutation.client";

const useHandleSportsbetRegister = () => {
  const [updateMyCurrency] = useUpdateMyDefaultCurrencyMutation();
  const [toggleMbtcMutation] = useToggleMbtcMutation();

  const handleSportsbetRegister = async () => {
    await updateMyCurrency({ currency: "BTC" });
    await toggleMbtcMutation({ mBTC: true });
  };

  return { handleSportsbetRegister };
};

export default useHandleSportsbetRegister;
